export const HYPERPURE_SIGNUP = "hyperpure_signup";
export const HYPERPURE_LOGIN = "hyperpure_login";
export const PETPOOJA_STORE_REGISTERED = "petpooja_store_registered";
export const HYPERPURE_FRAME_LOADED = "hyperpure_frame_loaded";
export const PETPOOJA_STORE_LINKED = "petpooja_store_linked";